import React from 'react';
import TabIndexBtn from '../Buttons/TabIndex';

import './style.scoped.scss';

const Tag = ({ text, comparisonTag, handleSelected }) => {
  return (
    <TabIndexBtn css={`p-0 m-0${comparisonTag ? ' w-100' : ''}`} handleClick={() => comparisonTag ? handleSelected(comparisonTag.text) : handleSelected(text)}>
      {comparisonTag ? (
        <div className="comparison-tag p-2 my-2">
          <p>{comparisonTag.leftCount}</p>
          <p>{comparisonTag.text}</p>
          <p>{comparisonTag.rightCount}</p>
        </div>
      ) : (
        <div className="tag badge badge-secondary p-1 m-1">
          <span className="mx-1">{text.trim()}</span>
        </div>
      )}
    </TabIndexBtn>
  );
};

export default Tag;
